"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.heroTabsTheme = void 0;
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _spacing = require("../../constants/spacing");
const heroTabsTheme = (0, _sdsThemeInternal.themed)({
  fontWeight: {
    "lodestar-light": "600",
    "ursa-light": "bold"
  },
  fontSize: {
    "lodestar-light": "14px",
    "ursa-light": "20px"
  },
  numberFontSize: {
    "lodestar-light": "40px",
    "ursa-light": "38px"
  },
  numberLineHeight: {
    "lodestar-light": "1",
    "ursa-light": "46px"
  },
  numberFontWeight: {
    "lodestar-light": "bold",
    "ursa-light": "700"
  },
  textMarginTop: {
    "lodestar-light": "2px",
    "ursa-light": `${_spacing.sizes.small}px`
  },
  textMarginBottom: {
    "lodestar-light": 0,
    "ursa-light": `${_spacing.sizes.small}px`
  },
  textMarginLeft: {
    "lodestar-light": `${_spacing.sizes.xSmall}px`,
    "ursa-light": 0
  },
  textFontSize: {
    "lodestar-light": "14px",
    "ursa-light": "20px"
  },
  textLineHeight: {
    "lodestar-light": "1.14",
    "ursa-light": "24px"
  },
  borderRight: {
    "lodestar-light": 0,
    "ursa-light": `-${_spacing.sizes.xSmall}px`
  },
  height: {
    "lodestar-light": "46px",
    "ursa-light": "unset"
  },
  gap: {
    "lodestar-light": 0,
    "ursa-light": "24px"
  },
  tabPaddingRight: {
    "lodestar-light": `${_spacing.sizes.xLarge}px`,
    "ursa-light": 0
  }
});
exports.heroTabsTheme = heroTabsTheme;
//# sourceMappingURL=heroTabsTheme.js.map